'use client'

import { useState } from 'react'
import { useTranslation } from '../hooks/useTranslation';
import { useCurrency } from '../contexts/CurrencyContext';

export default function CarComponent({ car: carData }) {
    const { selectedCurrency, convertPrice } = useCurrency();
    const { t } = useTranslation();
    const [car, setAllCars] = useState(carData);

    // WhatsApp Click Handler
    const handleWhatsAppClick = () => {
        const phoneNumber = "971507946317"; // without +
        const message = `Hello, I am interested in the ${car.name}, Brand: ${car.brandName}, Color: ${car.color}`;
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    };

    // Call Click Handler
    const handleCallClick = () => {
        window.location.href = `tel:${car.phone || '+974507946317'}`;
    };

    return (
        <div
            key={car.id}
            className="bg-[#2B2B2B] rounded-2xl overflow-hidden text-white shadow-lg relative"
        >
            {/* Image Section */}
            <div
                className="relative cursor-pointer"
                onClick={() => window.location.href = `/cars/${car.slug}`}
            >
                <img
                    src={car.thumbnail}
                    alt={car.name}
                    className="w-full h-[200px] object-cover p-[5px] rounded-[20px]"
                />

                {/* Brand Logo */}
                <img
                    src={car.brandLogo}
                    alt="Brand"
                    className="absolute top-3 left-3 w-8 h-8 bg-black/60 p-1 rounded-full"
                />
            </div>

            {/* Content */}
            <div className="px-4 pt-4">
                <div className="flex items-start justify-between gap-3">
                    <div>
                        <h3 className="text-[18px] font-semibold leading-tight">
                            {car.name}
                        </h3>
                        <p className="text-xs text-gray-400 mt-1">
                            {car.bodyType}
                        </p>
                    </div>

                    {/* Available Badge */}
                    <span className="text-[12px] px-3 py-1 rounded-full font-medium bg-[#62A862] whitespace-nowrap">
                        {t('extra.available')}
                    </span>
                </div>
            </div>

            {/* Specs */}
            <div className="px-4 py-4 space-y-3 text-sm text-gray-200">
                <div className="flex items-center gap-2">
                    <img src="/images/icons/manual.png" className="w-4 h-4" />
                    Automatic
                </div>

                <div className="flex items-center gap-2">
                    <img src="/images/icons/hp.png" className="w-4 h-4" />
                    {car.engine}
                </div>

                <div className="flex items-center gap-2">
                    <img src="/images/icons/mil.png" className="w-4 h-4" />
                    {car.mileage}
                </div>
            </div>

            {/* Bottom Row */}
            <div className="px-4 pb-4 flex items-center justify-between">
                <div className="text-xl font-semibold">
                    {selectedCurrency.symbol}{' '}
                    {selectedCurrency.code === 'USD'
                        ? car.pricePerDayUsd
                        : car.pricePerDayAed}
                    <span className="text-sm font-light text-gray-400">
                        {' '}per day
                    </span>
                </div>
            </div>

            {/* WhatsApp Floating Button */}
            <button
                onClick={handleWhatsAppClick}
                className="absolute bottom-4 right-4 p-3 rounded-full shadow-lg bg-[#4382D5]"
            >
                <img src="/images/icons/whatsapp.png" className="w-5 h-5" />
            </button>
        </div>
    );



}
